import React from 'react';
import '../styles/footer.scss'

import location from '../assets/pin.svg'
import phone from '../assets/phone.svg'

const Footer = () => (
    <div className="footer">
        <div className="footer-container">
            <div className="footer-section about">
                <h1>About</h1>
                <div className="divider"></div>
                <h3>Creative Nails has been offering an extensive range of nail services all throughout Summerville.</h3>
            </div>
            <div className="footer-section open-hours">
                <h1>Opening Hours</h1>
                <div className="divider"></div>
                <h3>Mon-Sat: 9:30am - 7pm</h3>
                <h3>Sun: 11am - 6pm</h3>
            </div>
            <div className="footer-section contact-info">
                <h1>Contact Information</h1>
                <div className="divider"></div>
                <h3><img src={location} width="25px" /> 220 Azalea Square Blvd B, Summerville, SC 29483</h3>
                <h3><img src={phone} width="25px" /> (843) 832-2400</h3>
            </div>
        </div>
        <div className="copyright"><p>© Copyright 2020 Creative Nails Summerville</p>
            <p>All Rights Reserved.</p></div>
    </div>
)

export default Footer